import React from 'react';
import { Link } from 'react-router-dom';
import { Music, ExternalLink, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const RecentReleases = () => {
  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute top-1/2 -translate-y-1/2 -right-40 w-[500px] h-[500px] rounded-full bg-[#D4A94F]/[0.04] blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-32">
            <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-5">
              <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
                Werdi Media Released
              </span>
            </div>
            <h2 className="text-white font-bold text-4xl md:text-5xl leading-tight tracking-tight mb-5">
              Playlist Rilisan
              <br />
              <span className="gold-gradient-text">Werdi Media</span>
            </h2>
            <p className="text-neutral-400 leading-relaxed mb-8">
              Ikuti playlist Werdi Media Released di Spotify — dengarkan
              100+ rilisan terbaru dari artis-artis binaan kami.
              Yang terbaru posisinya paling bawah.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                asChild
                className="rounded-full bg-[#1DB954] hover:bg-[#1ed760] text-white font-semibold px-6 h-12 btn-transition"
              >
                <a
                  href="https://open.spotify.com/playlist/3GE7XxugrSHUaOgfXeN4Is"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Music className="mr-2 w-4 h-4" />
                  Follow di Spotify
                  <ExternalLink className="ml-2 w-3.5 h-3.5" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                className="rounded-full bg-transparent border border-white/15 hover:border-[#D4A94F] hover:bg-[#D4A94F]/5 text-white font-semibold h-12 btn-transition"
              >
                <Link to="/rilisan">
                  Lihat Rilisan <ArrowRight className="ml-2 w-3.5 h-3.5" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-3xl border border-white/[0.06] bg-[#0d0d0d] overflow-hidden shadow-2xl">
              <iframe
                title="Werdi Media Released Spotify"
                src="https://open.spotify.com/embed/playlist/3GE7XxugrSHUaOgfXeN4Is?utm_source=generator&theme=0"
                width="100%"
                height="580"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                className="w-full block"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecentReleases;
